import { useDeviceType } from '@cian/ui-kit/responsive';
import { useSelector } from 'react-redux';

import { selectIsOfferPreviewOpen } from '../../../Map/selectors';

/**
 * Превью объявления открыто на телефоне: карточка или шторка мультипина внизу экрана, поверх контролов карты.
 * На планшете и десктопе превью - балун у пина, контролы оно не закрывает.
 */
export function useIsPhoneOfferPreviewOpen(): boolean {
  const deviceType = useDeviceType();
  const isPreviewOpen = useSelector(selectIsOfferPreviewOpen);

  return deviceType === 'phone' && isPreviewOpen;
}
